var $45375701f409adf1$exports = {};
$45375701f409adf1$exports = {
    "dismiss": `Zru\u{161}i\u{165}`
};


export {$45375701f409adf1$exports as default};
//# sourceMappingURL=sk-SK.module.js.map
